import {
  DEVICE_TYPE,
  type DeviceType,
} from "../../../viewer-express-api/src/constants";

export type DevShellDeviceType = DeviceType;

export interface DeviceTypeToggleOption {
  value: DevShellDeviceType;
  label: string;
  iconClass: string;
}

export const DEV_SHELL_DEVICE_TYPE_STORAGE_KEY = "devShellDeviceType";
export const DEFAULT_DEV_SHELL_DEVICE_TYPE: DevShellDeviceType = DEVICE_TYPE.WEB;

export const EXPRESS_DEVICE_TYPE_OPTIONS: readonly DeviceTypeToggleOption[] = [
  { value: DEVICE_TYPE.WEB, label: "Web", iconClass: "device-web" },
  { value: DEVICE_TYPE.IOS, label: "iOS", iconClass: "device-ios" },
  { value: DEVICE_TYPE.ANDROID, label: "Android", iconClass: "device-android" },
];

const EXPRESS_DEVICE_TYPES = new Set<DevShellDeviceType>(Object.values(DEVICE_TYPE));

export const shouldShowDeviceTypeToggle = (
  isOfflinePackage: boolean,
  isExpressBuild: boolean,
  minimalShell = false,
  isUatBuild = false,
): boolean =>
  isOfflinePackage && isExpressBuild && !minimalShell && !isUatBuild;

export const isDevShellExpressDeviceType = (
  value: string | null | undefined,
): value is DevShellDeviceType =>
  EXPRESS_DEVICE_TYPES.has(value as DevShellDeviceType);

const normalizeStoredDeviceType = (stored: string | null): DevShellDeviceType => {
  if (isDevShellExpressDeviceType(stored)) {
    return stored;
  }
  return DEFAULT_DEV_SHELL_DEVICE_TYPE;
};

export const getExpressShellTitle = (
  deviceType: DevShellDeviceType = DEFAULT_DEV_SHELL_DEVICE_TYPE,
  showDeviceTypeInTitle = false,
  isUatBuild = false,
): string => {
  if (showDeviceTypeInTitle) {
    return `BV Express · ${deviceType}`;
  }
  return isUatBuild ? "Express UAT" : "BV Express";
};

/** Per-tab preference: new tabs default to web; reload keeps the current tab selection. */
export const readStoredDeviceType = (): DevShellDeviceType => {
  try {
    const stored = sessionStorage.getItem(DEV_SHELL_DEVICE_TYPE_STORAGE_KEY);
    return normalizeStoredDeviceType(stored);
  } catch {
    // sessionStorage may be unavailable in some test environments.
  }
  return DEFAULT_DEV_SHELL_DEVICE_TYPE;
};

export const writeStoredDeviceType = (deviceType: DevShellDeviceType): void => {
  if (!isDevShellExpressDeviceType(deviceType)) {
    return;
  }

  try {
    sessionStorage.setItem(DEV_SHELL_DEVICE_TYPE_STORAGE_KEY, deviceType);
  } catch {
    // Ignore write failures in restricted environments.
  }
};
